import { color, Common } from '@stockbit/ui';
import { useRouter } from 'next/router';
import Link from 'next/link';

import Image from 'global/Image';
import useSearchCompanyModalStore from 'global/Securities/stores/useSearchCompanyModalStore';
import { withMaintenanceGuard } from 'global/Securities/utils/maintenance';
import useSecuritiesButton from 'features/securities/hooks/useSecuritiesButton';
import realTradingMenu, { MenuItem } from './realTadingMenu';
import { Grid, NavigationMobile } from './styled';
import { BuyButton } from './Mobile.styled';

const { Flex, Iconmoon, IconWrapper, Text } = Common;

const subMenuList = realTradingMenu.map(({ subMenu }) => subMenu).flat();

const Mobile = () => {
  const router = useRouter();
  const openSearchCompanyModal = useSearchCompanyModalStore((s) => s.showModal);
  const { handleLogoutTrading, handleClickSupportButton } =
    useSecuritiesButton();

  const handleBuyClick = () =>
    withMaintenanceGuard(() => {
      openSearchCompanyModal();
    });

  const handleClickMenu = (data: MenuItem) => {
    if (data.label === 'Trading Logout') {
      handleLogoutTrading();
    }

    if (data.label === 'Live Support') {
      handleClickSupportButton();
    }
  };

  return (
    <>
      <Flex direction="column" p="16px">
        <Flex align="center">
          <IconWrapper size="40px" style={{ marginRight: 4 }}>
            <Image
              src="/img/ssd.svg"
              alt="logo-sekuritas"
              style={{ width: '100%' }}
            />
          </IconWrapper>
          <Text>Trading Area</Text>
        </Flex>
        <BuyButton onClick={handleBuyClick}>BUY</BuyButton>
      </Flex>

      <Grid>
        {subMenuList.map((data) => (
          <Link href={data.link} passHref key={data.label}>
            <NavigationMobile
              key={data.label}
              onClick={() => handleClickMenu(data)}
            >
              <Iconmoon
                className={data.iconmoonMobile}
                color={data.matcher(router) ? color.primary : color.dimgray}
                size="24px"
              />
              <Text
                as="a"
                size="11px"
                align="center"
                color={data.matcher(router) ? color.primary : color.dimgray}
              >
                {data.label}
              </Text>
            </NavigationMobile>
          </Link>
        ))}
      </Grid>
    </>
  );
};

export default Mobile;
